<video #videoElement [id]="type=='LIVE_VIEW'?'videojs-flash-player-'+camera?.id:'videojs-flash-player-'+record?.id"
 class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" [style]="type!=='LIVE_VIEW'?'background-image:url(\'assets/images/poster.jpg\');background-size: contain;':'height: 100%;'" >
  <source type="video/mp4" src="null">
</video>